import { IPlugin, PluginStore } from "react-pluggable";
import KoszykLiscieckiFooter from "./components/KoszykLisieckiFooter/KoszykLisieckiFooter";
class SetKoszykLisieckiFooterPlugin implements IPlugin {

    pluginStore!: PluginStore;

    getPluginName(): string {
        return "SetKoszykLisieckiFooter@1.0.0"
    }
    getDependencies(): string[] {
        return [];
    }
    init(pluginStore: PluginStore): void {
        this.pluginStore = pluginStore;
    }
    activate(): void {
        this.pluginStore.executeFunction("Renderer.add", "page:footer", () => (
            <KoszykLiscieckiFooter></KoszykLiscieckiFooter>
        ));
    }
    deactivate(): void { }
}

export default SetKoszykLisieckiFooterPlugin